export const addZero = (digitsLength: number, source: number) => {
    let text = source.toString();

    while (text.length < digitsLength) text = `0${text}`;

    return text;
};
